import request from 'api/request';

export default function schoolCourseIndexRoute(school) {
  return request({ url: '/schools/courses', data: { school } });
}
